import axios from 'axios';

import { handleError } from '@/shared/services/api';

export default {
  baseUrl(id) {
    let url = `${window.api_url}/organization/courses`;
    if (id) url += `/${id}`;
    return url;
  },

  create(course) {
    return axios.post(this.baseUrl(), { course }).catch(handleError);
  },

  destroy(id, success) {
    if (!success) return axios.delete(this.baseUrl(id));
    return axios.delete(this.baseUrl(id)).then(success);
  },

  get(id) {
    return axios.get(this.baseUrl(id)).catch(handleError);
  },

  index(params) {
    return axios.get(this.baseUrl(), { params }).catch(handleError);
  },

  update(id, course, success, failure) {
    axios.patch(this.baseUrl(id), { course }).then(success).catch(failure);
  },
};
